import { MD3DarkTheme } from "react-native-paper";
import type { MD3Theme } from "react-native-paper";

import { BOARD_BG, ROLE_COLORS } from "./boardColors";

export { BOARD_BG, ROLE_COLORS };

const synapseColors = {
  primary: "#ffffff",
  secondary: ROLE_COLORS.start,
  tertiary: "#FFD3B6", // Pastel orange (greedy/strategic moves)
  greedyMoveColor: "#FFD3B6",
  strategicRepositioningMoveColor: "#FFD3B6",
};

// Define the extended theme structure
export interface ExtendedTheme extends MD3Theme {
  customColors: {
    startNode: string;
    endNode: string;
    currentNode: string;
    pathNode: string;
    globalOptimalNode: string;
    localOptimalNode: string;
    aiPath: string;
    greedyMove: string;
    strategicRepositioningMove: string;
    // New colors for stats modal
    warningColor: string;
    achievementChip: string;
    achievementIcon: string;
    progressBadge: string;
    collectedWordChip: string;
  };
}

// Dark theme - the only theme used in the app
export const SynapseDarkTheme: ExtendedTheme = {
  ...MD3DarkTheme,
  colors: {
    ...MD3DarkTheme.colors,
    primary: synapseColors.primary,
    secondary: synapseColors.secondary,
    tertiary: synapseColors.tertiary,
    background: BOARD_BG,
    surface: "#1e1e1e",
    backdrop: "rgba(0, 0, 0, 0.7)",
    // Neutral overrides for the remaining MD3 roles, so Material's default
    // purple baseline never shows through (buttons, snackbars, cards, tabs).
    onPrimary: "#121212",
    primaryContainer: "#2A2A2A",
    onPrimaryContainer: "#FFFFFF",
    secondaryContainer: "#2E3A44",
    onSecondaryContainer: "#EAEAEA",
    surfaceVariant: "#262626",
    onSurfaceVariant: "#B3B3B3",
    outline: "#4A4A4A",
    outlineVariant: "#333333",
    inverseSurface: "#2A2A2A",
    inverseOnSurface: "#EAEAEA",
    inversePrimary: ROLE_COLORS.current,
    errorContainer: "#2A1A1B",
    onErrorContainer: ROLE_COLORS.target,
    elevation: {
      level0: "transparent",
      level1: "#1E1E1E",
      level2: "#232323",
      level3: "#272727",
      level4: "#2A2A2A",
      level5: "#2D2D2D",
    },
  },
  // Custom colors in a separate property. Chip/badge colours derive from
  // the board roles: one gold, one purple app-wide.
  customColors: {
    startNode: ROLE_COLORS.start,
    endNode: ROLE_COLORS.target,
    currentNode: ROLE_COLORS.current,
    pathNode: ROLE_COLORS.path,
    globalOptimalNode: ROLE_COLORS.gold,
    localOptimalNode: ROLE_COLORS.purple,
    aiPath: ROLE_COLORS.ai,
    greedyMove: synapseColors.greedyMoveColor,
    strategicRepositioningMove: synapseColors.strategicRepositioningMoveColor,
    warningColor: ROLE_COLORS.target,
    achievementChip: ROLE_COLORS.gold,
    achievementIcon: ROLE_COLORS.gold,
    progressBadge: ROLE_COLORS.start,
    collectedWordChip: ROLE_COLORS.current,
  },
};

// Default theme is dark (the only theme)
export default SynapseDarkTheme;
